import tw, { styled } from 'twin.macro';

export const ThirdPartyShareWrapper = styled.div`
  ${tw`flex flex-col bg-white shadow items-center fixed px-2 py-4 gap-3 top-1/2 transform -translate-y-1/2 right-0 rounded-l-lg`};

  .tooltip {
    ${tw`bg-white hidden right-6 z-10`};
    position: absolute !important;
  }

  .share {
    ${tw`flex flex-col justify-center items-center gap-2`};
    line-height: 15.18px;
    font-weight: 450;
    font-size: 11px;
    color: #676767;
  }

	.icon-wrapper {
    ${tw`relative cursor-pointer`};

    a {
      ${tw`flex items-center justify-center w-9 h-9 bg-white shadow rounded-full p-1.5`};

      img {
        ${tw`w-full h-full`};
      }
    }
		
    @media(min-width: 767px) {
      &:hover .tooltip {
        ${tw`inline`};
      }
    }
	}

  @media(max-width: 767px) {
    ${tw`w-full flex-row justify-around absolute top-auto rounded-t-lg left-0`};

		.share {
			${tw`flex-row`};
		}
	}

  &.builder-preview {
    ${tw`right-3`};
    
    &:not(.desktop) {
      ${tw`w-full flex-row justify-around absolute top-auto rounded-t-lg left-0`};

      .icon-wrapper:hover .tooltip {
        ${tw`hidden`};
      }

      .share {
        ${tw`flex-row`};
      }
    }
  }
`;